import { useCommandPaletteContext } from '@/features/CommandPalette/CommandPaletteContext';
import { Tooltip } from '@/components';
import Button from '@imminently/decisively-ui/Button';
import { Kbd } from '@imminently/decisively-ui/Kbd';
import Icon from '@imminently/decisively-ui/Icon';

export const CommandSearch = () => {
  const { open } = useCommandPaletteContext();

  return (
    <>
      {/* Mobile / below lg: icon only with tooltip */}
      <Tooltip title={<span className="flex items-center gap-1">Search (<Kbd inline variant="text" color="dark" keys={['mod', 'k']} />)</span>} placement="bottom">
        <Button label="Search"
          icon
          variant="ghost"
          intent="sidebar"
          onClick={open}
          className="lg:hidden"
        >
          <Icon name="search" />
        </Button>
      </Tooltip>

      {/* lg+: full search button */}
      <Button
        label="Search..."
        variant="contained"
        intent="sidebar"
        onClick={open}
        className="hidden lg:flex items-center gap-2 h-8 w-48 px-3 mr-4 text-sm rounded-xl bg-neutral-900 text-neutral-300 hover:text-neutral-100 justify-start font-normal transition-colors duration-150 border border-neutral-700/50 hover:border-neutral-600"
      >
        <Icon name="search" className="w-4 h-4 shrink-0" />
        <span className="grow text-left">Search...</span>
        <Kbd inline variant="text" color="dark" keys={['mod', 'k']} />
      </Button>
    </>
  );
};
